export default __webpack_public_path__ + "static/media/privacy-policy.5e3747df.jpg";